module.exports = __webpack_public_path__ + "static/media/star.4e820c2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/AddReview/star.svg
// module id = 307
// module chunks = 0